import React from "react";

const Text = ({
  data,
  label,
  name,
  handleInputChange,
  width,
  type,
  placeholder,
  is_invalid,
}) => {
  return (
    <>
      <div className="form-group">
        <label style={{ fontSize: "15px" }} htmlFor={name}>
          {label}
        </label>
        <input
          type={type}
          className={`form-control ${is_invalid && "is-invalid"}`}
          id={name}
          name={name}
          value={data ? data : ""}
          onChange={handleInputChange}
          placeholder={placeholder}
          style={{ width: `${width}%` }}
        />
      </div>
    </>
  );
};

export default Text;
